// app/javascript/controllers/auto_select_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field", "form", "button", "disabledButtonContent", "enabledButtonContent"]
  // Debounces requestSubmit() when set (ms). Opt-in and 0 by default: forms with a single,
  // discrete field (a toggle, a select) still submit the moment they change; this only matters
  // for forms with several fields a user tabs through quickly (e.g. the structure manager rate
  // inputs), where every field's own change event would otherwise fire its own overlapping request.
  static values = { debounce: { type: Number, default: 0 } }

  connect() {}

  submitForm() {
    if (this.formTarget.dataset.required && this.hasFieldTarget) {
      if (this.fieldTarget.value === "") return;
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener('click', (event) => { event.preventDefault() })
      this.enabledButtonContentTarget.classList.add('hidden')
      this.disabledButtonContentTarget.classList.remove('hidden')
    }

    if (this.debounceValue > 0) {
      clearTimeout(this.submitTimeout);
      this.submitTimeout = setTimeout(() => this.formTarget.requestSubmit(), this.debounceValue);
      return;
    }

    this.formTarget.requestSubmit()
  }

  disconnect() {
    clearTimeout(this.submitTimeout);
  }
}
